var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg48IconDonate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#f4f3f0",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1200.746 -4616.53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.157,32.5a2.453,2.453,0,0,0-3.3.235l-.348.351-.348-.351a2.453,2.453,0,0,0-3.3-.235,2.451,2.451,0,0,0-.175,3.6l3.419,3.458a.562.562,0,0,0,.8,0L8.33,36.1a2.449,2.449,0,0,0-.173-3.6Z",
    transform: "translate(1219.448 4599.904)",
    fill: "none",
    stroke: "#816920",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.337,44.2a1.7,1.7,0,0,0-1.909,0L19.286,47a3.194,3.194,0,0,1-1.793.531h-5.3a.615.615,0,1,1,0-1.213H15.7a1.453,1.453,0,0,0,1.49-1.009,1.006,1.006,0,0,0,.021-.207,1.338,1.338,0,0,0-1.434-1.211H8.606a5.9,5.9,0,0,0-3.321,1L3.2,46.319H.717A.669.669,0,0,0,0,46.926v3.64a.669.669,0,0,0,.717.607H16.709a3.212,3.212,0,0,0,1.793-.531l6.779-4.588a1.16,1.16,0,0,0,.538-.916,1.136,1.136,0,0,0-.481-.938Z",
    transform: "translate(1212.573 4599.594)",
    fill: "#816920",
    stroke: "#816920",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg48IconDonate);
export default __webpack_public_path__ + "static/media/48-icon-donate.0aee7553.svg";
export { ForwardRef as ReactComponent };